import { render } from "./AppSidebarNav.vue?vue&type=template&id=58688374&scoped=true"
import script from "./AppSidebarNav.vue?vue&type=script&lang=js"
export * from "./AppSidebarNav.vue?vue&type=script&lang=js"

import "./AppSidebarNav.vue?vue&type=style&index=0&id=58688374&lang=scss&scoped=true"
import "./AppSidebarNav.vue?vue&type=style&index=1&id=58688374&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58688374"]])

export default __exports__